export const LOGIN_REQUEST = "login";
export const SIGNUP_REQUEST = "signup";
